/** @format */

import {AccountDesignsOrdersContext} from 'frontier/account/components/context/AccountDesignsOrdersContext';
import {Modal, ModalHeader, ModalFooter} from '@sttark/design-system';
import useDesignArchive from '../../shared/use_design_archive';
import {Button} from '@sttark/design-system';
import {IfElse} from 'frontier-utilities';
import React, {useContext} from 'react';

export const ArchiveDesign = () => {
    const designCtx = useContext(AccountDesignsOrdersContext);

    const onUnarchive = () => designCtx.handleToggleIsArchived(false);
    const onArchive = () => designCtx.handleToggleIsArchived(true);
    const designId = designCtx.design.id;

    const {
        toggleIsShowingArchive,
        isArchivingDesignDone,
        isShowingArchiveForm,
        isArchivingDesign,
        handleUnarchive,
        handleArchive
    } = useDesignArchive(designId, onArchive, onUnarchive);

    return (
        <>
            <IfElse condition={designCtx.design.is_archived}>
                <div>
                    <div
                        className="p-0 m-0 color-accent-tertiary d-flex align-items-center justify-content-start"
                        style={{color: '#E5B200'}}>
                        <i className="fa fa-triangle-exclamation me-2" />
                        <span>Design archived</span>
                    </div>
                    <button
                        className="p-0 m-0 color-accent-primary d-flex align-items-center justify-content-start"
                        onClick={handleUnarchive}>
                        <i className="fa fa-undo me-2" />
                        <u>Un-archive design</u>
                    </button>
                </div>
                <IfElse condition={!isArchivingDesign}>
                    <button
                        className="p-0 m-0 color-alert-negative d-flex align-items-center justify-content-start"
                        onClick={toggleIsShowingArchive}>
                        <i className="fa fa-trash me-2" />
                        <u>Archive design</u>
                    </button>
                    <div className="d-flex align-items-center justify-content-start gap-2">
                        <i className="fa fa-spinner fa-spin" />
                        <span>Archiving...</span>
                    </div>
                </IfElse>
            </IfElse>
            <Modal isOpen={isShowingArchiveForm} onClose={toggleIsShowingArchive} bodyHeightAuto>
                <ModalHeader>Archive design</ModalHeader>
                <IfElse condition={!designCtx.design.is_archived}>
                    <div>
                        <h5 style={{margin: '0 0 8px'}}>Archiving design will:</h5>
                        <p className="m-0 p-0">
                            Archive this design only and and not the whole order. You can un-archive
                            at any time from the archived tab.
                        </p>
                    </div>
                    <div>
                        <h5 style={{margin: '0 0 8px'}}>Design archived</h5>
                        <p className="m-0 p-0">You have archived this design.</p>
                    </div>
                </IfElse>
                <ModalFooter>
                    <IfElse condition={!isArchivingDesign}>
                        <IfElse condition={!designCtx.design.is_archived}>
                            <div className="d-flex align-items-center justify-content-end gap-4">
                                <Button onClick={toggleIsShowingArchive} label="Cancel" secondary />
                                <Button
                                    onClick={handleArchive}
                                    label="Archive Design"
                                    destructive
                                />
                            </div>
                            <div className="d-flex align-items-center justify-content-end gap-2">
                                <i className="color-accent-primary fa fa-check" />
                                <span className="color-accent-primary">Archived</span>
                            </div>
                        </IfElse>
                        <div className="d-flex align-items-center justify-content-end gap-2">
                            <i className="fa fa-spinner fa-spin" />
                            <span>Archiving...</span>
                        </div>
                    </IfElse>
                </ModalFooter>
            </Modal>
        </>
    );
};
